import script from "./SideNavContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./SideNavContainer.vue?vue&type=script&setup=true&lang=js"

import "./SideNavContainer.vue?vue&type=style&index=0&id=fc902f00&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc902f00"]])

export default __exports__